"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const v4_1 = require("zod/v4");
exports.artifactType = 'receivableResponseTape';
// Zod schema and new types
exports.NodeConfigSchema = v4_1.z
    .object({
    operationDescription: v4_1.z
        .string()
        .describe('Description shown in the operation node'),
    tapeDescription: v4_1.z.string().describe('Description shown in the tape node'),
    useReceivableWaivers: v4_1.z
        .boolean()
        .optional()
        .describe('Whether to apply receivable waivers'),
})
    .describe('Configuration for receivableResponseTape node');
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    externalFilename: v4_1.z.null(),
    type: v4_1.z.literal(exports.artifactType),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map